import type {
	Exact,
	InputMaybe,
	Scalars,
	ShoppingCartAddItemInput,
	ShoppingCartOrderByInput,
} from 'codegen/src/gateway/types'
import type {
	FragmentInstallmentPaymentFragment,
	FragmentItemsFieldsFragment,
	FragmentLimitsFieldsFragment,
	FragmentPromotionDtoFieldsFragment,
	FragmentSummaryDtoFieldsFragment,
} from '../fragments.generated'
import {
	FragmentInstallmentPaymentFragmentDoc,
	FragmentItemsFieldsFragmentDoc,
	FragmentLimitsFieldsFragmentDoc,
	FragmentPromotionDtoFieldsFragmentDoc,
	FragmentSummaryDtoFieldsFragmentDoc,
} from '../fragments.generated'

export type AddItemMutationVariables = Exact<{
	channel: Scalars['String']['input']
	item: ShoppingCartAddItemInput
	orderBy?: InputMaybe<ShoppingCartOrderByInput>
	canApplyPromoCode?: InputMaybe<Scalars['Boolean']['input']>
	countryIso3166_2?: InputMaybe<Scalars['String']['input']>
}>

export type AddItemMutation = {
	addItem?: {
		totalItems: number
		items: Array<FragmentItemsFieldsFragment | null>
		deliveries: Array<{
			order: number
			items: Array<FragmentItemsFieldsFragment | null>
		} | null>
		summary: FragmentSummaryDtoFieldsFragment
		promotion?: FragmentPromotionDtoFieldsFragment | null
		metadata: {
			limitsExceeded: boolean
			limits: FragmentLimitsFieldsFragment
			installmentPayment?: FragmentInstallmentPaymentFragment | null
		}
		communicationMessages?: Array<{
			id?: string | null
			key?: string | null
		} | null> | null
	} | null
}

export const AddItemDocument = `
    mutation AddItem($channel: String!, $item: ShoppingCartAddItemInput!, $orderBy: ShoppingCartOrderByInput, $canApplyPromoCode: Boolean, $countryIso3166_2: String) {
  addItem(
    channel: $channel
    item: $item
    orderBy: $orderBy
    canApplyPromoCode: $canApplyPromoCode
    countryIso3166_2: $countryIso3166_2
  ) {
    items {
      ...FragmentItemsFields
    }
    deliveries {
      order
      items {
        ...FragmentItemsFields
      }
    }
    summary {
      ...FragmentSummaryDtoFields
    }
    promotion {
      ...FragmentPromotionDtoFields
    }
    totalItems
    metadata {
      limits {
        ...FragmentLimitsFields
      }
      limitsExceeded
      installmentPayment {
        ...FragmentInstallmentPayment
      }
    }
    communicationMessages {
      id
      key
    }
  }
}
    ${FragmentItemsFieldsFragmentDoc}
${FragmentSummaryDtoFieldsFragmentDoc}
${FragmentPromotionDtoFieldsFragmentDoc}
${FragmentLimitsFieldsFragmentDoc}
${FragmentInstallmentPaymentFragmentDoc}`
